import { Auditable, HasId } from '../common';
import { Upload, UploadId } from '../upload';
import { SocketMessage, SocketMessageEvent } from '../sockets/messages';
import { LocationId } from './Location';

export interface LocationMap extends HasId, Auditable {
    locationId: LocationId;
    lon: string;
    lat: string;
    zoom: number;
    dpi: number;
    failedToGenerate: boolean;
    uploadId: UploadId | null;
    upload?: Upload;
    vectorId: UploadId | null;
    vector?: Upload;
}

export interface LocationMapSale {
    clientName: string;
    locationName: string;
    amountInCents: number;
    currency: string;
    purchasedAt: Date;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type MapGeneratedSocketMessage = SocketMessage<{}>;
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export const MapGeneratedSocketMessageEvent = new SocketMessageEvent<{}>('mapGenerated');
